import React from 'react';
import { Button } from '@/components/ui/button';
import { 
  LayoutDashboard, ClipboardList, Map, Users, ShoppingCart,
  Wallet, UserCircle, Settings, ChevronLeft, ChevronRight,
  LogOut, Printer, Building2
} from 'lucide-react';

const MENU_ITEMS = [
  // === KERN-FUNKTIONEN für Go-Live ===
  { id: 'dashboard', icon: LayoutDashboard, label: 'Übersicht', color: 'text-blue-400' },
  { id: 'orders', icon: ClipboardList, label: 'Bestellungen', color: 'text-green-400' },
  { id: 'pos', icon: ShoppingCart, label: 'Kasse', color: 'text-emerald-400' },
  { id: 'settings', icon: Settings, label: 'Einstellungen', color: 'text-gray-400' },
  // Deaktiviert für Go-Live (Phase 2):
  // { id: 'map', icon: Map, label: 'Stadtplan', color: 'text-purple-400' },
  // { id: 'employees', icon: Users, label: 'Mitarbeiter', color: 'text-amber-400' },
  // { id: 'cashbook', icon: Wallet, label: 'Kassenbuch', color: 'text-rose-400' },
  // { id: 'customers', icon: UserCircle, label: 'Kunden', color: 'text-cyan-400' },
];

export default function Sidebar({ 
  collapsed, 
  onToggle, 
  activeSection, 
  onSectionChange,
  businessName,
  onLogout,
  onStationChange
}) {
  return (
    <div 
      className={`
        ${collapsed ? 'w-16' : 'w-64'} 
        bg-[#0a0a0f] border-r border-gray-800 
        flex flex-col transition-all duration-300 ease-in-out
        h-screen sticky top-0
      `}
    >
      {/* Header */}
      <div className={`p-4 border-b border-gray-800 ${collapsed ? 'px-2' : ''}`}>
        <div className="flex items-center justify-between">
          {!collapsed && (
            <div className="flex items-center gap-3">
              <img 
                src="/cash-x-logo.png" 
                alt="Cash-X" 
                className="h-12 w-auto object-contain"
              />
              <div>
                <div className="text-xs text-gray-500 truncate max-w-[140px]">{businessName}</div>
              </div>
            </div>
          )}
          {collapsed && (
            <img 
              src="/cash-x-logo.png" 
              alt="Cash-X" 
              className="h-10 w-auto mx-auto object-contain"
            />
          )}
        </div>
      </div>

      {/* Toggle Button */}
      <Button
        variant="ghost"
        size="sm"
        onClick={onToggle}
        className="absolute -right-3 top-16 w-6 h-6 rounded-full bg-gray-800 border border-gray-700 p-0 hover:bg-gray-700 z-10"
      >
        {collapsed ? (
          <ChevronRight className="w-4 h-4 text-gray-400" />
        ) : (
          <ChevronLeft className="w-4 h-4 text-gray-400" />
        )}
      </Button>

      {/* Navigation */}
      <nav className="flex-1 py-4 overflow-y-auto">
        <div className="space-y-1 px-2">
          {MENU_ITEMS.map((item) => {
            const Icon = item.icon;
            const isActive = activeSection === item.id;
            
            return (
              <Button
                key={item.id}
                variant="ghost"
                onClick={() => onSectionChange(item.id)}
                className={`
                  w-full justify-start gap-3 h-11
                  ${collapsed ? 'px-0 justify-center' : 'px-3'}
                  ${isActive 
                    ? 'bg-gray-800/80 text-white' 
                    : 'text-gray-400 hover:text-white hover:bg-gray-800/50'}
                  transition-all duration-200
                `}
                title={collapsed ? item.label : undefined}
              >
                <Icon className={`w-5 h-5 flex-shrink-0 ${isActive ? item.color : ''}`} />
                {!collapsed && (
                  <span className="truncate">{item.label}</span>
                )}
                {isActive && !collapsed && (
                  <div className={`ml-auto w-1.5 h-1.5 rounded-full ${item.color.replace('text-', 'bg-')}`} />
                )}
              </Button>
            );
          })}
        </div>
      </nav>

      {/* Footer Actions */}
      <div className="p-2 border-t border-gray-800 space-y-1">
        {/* Station Change */}
        <Button
          variant="ghost"
          onClick={onStationChange}
          className={`
            w-full justify-start gap-3 h-10 text-purple-400 hover:text-purple-300 hover:bg-purple-500/10
            ${collapsed ? 'px-0 justify-center' : 'px-3'}
          `}
          title={collapsed ? "Station wechseln" : undefined}
        >
          <Printer className="w-5 h-5 flex-shrink-0" />
          {!collapsed && <span>Station wechseln</span>}
        </Button>

        {/* Logout */}
        <Button
          variant="ghost"
          onClick={onLogout}
          className={`
            w-full justify-start gap-3 h-10 text-red-400 hover:text-red-300 hover:bg-red-500/10
            ${collapsed ? 'px-0 justify-center' : 'px-3'}
          `}
          title={collapsed ? "Abmelden" : undefined}
        >
          <LogOut className="w-5 h-5 flex-shrink-0" />
          {!collapsed && <span>Abmelden</span>}
        </Button>
      </div>
    </div>
  );
}
